<!--
  Header height: the 88px desktop band is implied by the header's own content
  geometry — the 48px logo and the 32px "Sign out" pill, both centred via
  `flex items-center`, sit exactly at their intended y-offsets inside 88px
  ((88-48)/2=20, (88-32)/2=28).
  `#main`'s `top-*` MUST stay equal to this height, or content renders
  underneath the header.
  Mobile (`h-12`, 48px) is left as-is — no mobile chrome spec exists to size
  against (see the header component's own comments re: mobile).

  z-10: both this wrapper and `#main` below are `position: fixed`
  with no z-index of their own, so DOM order alone decides the stacking —
  without it `#main` paints over the header, clipping any overflow from the
  header's own gradient scrim (seat-selection). z-10 puts this wrapper above the map
  and, by making it a stacking context, keeps the scrim's own negative
  z-index local instead of letting it fall behind the map.
-->
<div class="z-10 fixed top-0 h-12 md:h-[88px] w-full">
  <app-header></app-header>
</div>

<!-- Loading screen -->
<!-- <app-loader></app-loader> -->

<!--
  `#main` top offset: everywhere else the page starts
  below the fixed header (`top-12`/`top-[88px]`). On seat-selection specifically
  it starts at `top-0` instead, so the DVM map genuinely renders behind the header's transparent
  gradient scrim (header.component.html's `showLegend` branch) rather than the header floating
  over an opaque plate standing in for the map. Seat-selection's own topbar/sidebar add their own
  top clearance to compensate (see viewer.component.html and sidebar.component.html) — this is
  the one route where the header is meant to overlap page content on purpose.
-->
<div
  id="main"
  class="w-full fixed bottom-0 overflow-auto"
  [ngClass]="isSeatSelectionRoute ? 'top-0' : 'top-12 md:top-[88px]'">
  <router-outlet></router-outlet>
</div>

<!-- Error -->
<!-- <app-error-modal></app-error-modal> -->
